import {
  SERVICE_HOLDER_COMPANION_ALONE,
  SERVICE_HOLDER_COMPANION_OTHER,
  SERVICE_HOLDER_COMPANION_WITH_PARTNER,
  SERVICE_HOLDER_COMPANION_WITH_RELATIVE,
} from "./serviceHolder";

const units = [
  {
    value: SERVICE_HOLDER_COMPANION_ALONE,
  },
  {
    value: SERVICE_HOLDER_COMPANION_WITH_PARTNER,
  },
  {
    value: SERVICE_HOLDER_COMPANION_WITH_RELATIVE,
  },
  {
    value: SERVICE_HOLDER_COMPANION_OTHER,
  },
];

export function familiarUnitsList() {
  return units;
}
